export const visit = (vm, at) => {
at({ "es": { "conversations-message-history": { "status": { "closed": "Este hilo fue cerrado el {{ dateString }}.", "restore": "Restaurar este mensaje", "publishing": { "UNPUBLISHED": "Enviando...", "PUBLISH_FAILED": "No entregado. Haga clic para volver a intentar." } } } } });
};